import React from 'react'

export const About = () => (
  <div class="jumbotron">
    <div class="container">
      <h1 class="display-4">Лучшее React приложение</h1>
      <p class="lead">
        Версия приложения <strong>1.0.42</strong>
      </p>
    </div>
  </div>
)